/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/61233374
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import filter from 'ramda/src/filter';
import includes from 'ramda/src/includes';
import isNil from 'ramda/src/isNil';
import isEmpty from 'ramda/src/isEmpty';
import length from 'ramda/src/length';
import prop from 'ramda/src/prop';
import slice from 'ramda/src/slice';
import sortBy from 'ramda/src/sortBy';
import Avatar from '@components/@core/Avatar';
import DatePicker from '@components/@core/DatePicker';
import EditDropdown from '@components/EditDropdown';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import AppActions from '~/actions/app';
import CommunityActions from '~/actions/community';
import ManageActions from '~/actions/manage';
import { exportCsv } from '~/services/util-excel';
import withNavigate from '~/hocs/withNavigate';
import { BirthdayPDF } from './BirthdayPDF';
const moment = extendMoment(originalMoment);
const today = moment();

class Birthday extends Component {
    state = {
        date: moment.range(today.clone(), today.clone().add(1, 'year')),
        currentPage: 1,
        perPage: 25,
        company: this.props.company,
        userIds: [],
        base: 'birthday',
        orderBy: 'days_remaining',
        asc: true,
        month_start: '',
        month_end: '',
    };

    componentDidMount() {
        const { base, asc, company, orderBy, month_start, month_end } = this.state;
        this.handleFetchBirthday(company.id, base, orderBy, asc, month_start, month_end);
    }

    handleFetchBirthday(companyId, base, order_by, asc, month_start, month_end) {
        const payload = { order_by, order: asc ? 'ASC' : 'DESC', month_start, month_end };
        this.props.getBirthdayReport(companyId, base, payload);
    }

    handleFilter = (type, e) => {
        const { base, asc, orderBy, month_start, month_end } = this.state;
        if (type === 'company') {
            const company = e[0].id < 0 ? this.state.company : e[0];
            this.handleFetchBirthday(company.id, base, orderBy, asc, month_start, month_end);
            this.setState({ company });
        } else {
            const userIds = e.length === 0 || e[0].id < 0 ? [] : e.map((item) => item.id);
            this.setState({ userIds });
        }
    };

    handleDate = (e) => {
        const { company, base, asc } = this.state;
        const date = moment.range(moment(e.start).format('MM/DD/YYYY'), moment(e.end).format('MM/DD/YYYY'));
        const month_start = date.start.format('MM');
        const month_end = date.end.format('MM');
        this.handleFetchBirthday(company.id, base, event, asc, month_start, month_end);
        this.setState({ date, month_start, month_end });
    };

    handlePage = (e) => {
        this.setState({ currentPage: e });
    };

    handlePer = (e) => {
        this.setState({ perPage: e });
    };

    handleSort = (event) => {
        const { base, asc, company, month_start, month_end } = this.state;
        this.handleFetchBirthday(company.id, base, event, asc, month_start, month_end);
        this.setState({ orderBy: event, asc: !asc });
    };

    handleMenu = (e) => {
        const payload = { userId: e.community_user_id };
        this.props.getUser(payload, `/${e.community_user.entity.slug}/about`);
    };

    handleExcelReport = () => {
        this.props.toggleModal({
            type: 'Confirm',
            data: {
                before: {
                    title: 'Confirm',
                    body: 'Would you like to download this reports data to excel?',
                },
            },
            callBack: {
                onYes: () => {
                    this.handleExcel();
                },
            },
        });
    };

    handleExcel = () => {
        const { birthdayReport } = this.props;

        const employees = isEmpty(birthdayReport.active) ? [] : birthdayReport.active.employees;
        let birthday = [];

        employees.forEach((employee) => {
            const excelData = {
                Name: employee.name,
                Company: employee.company_name,
                Departments: employee.department_name,
                Birthday: isNil(employee.birthday) || isEmpty(employee.birthday) ? 'NA' : moment(employee.birthday).format('MMM DD, YYYY'),
                'Hire Date': moment(employee.hired_at).format('MMM DD, YYYY'),
            };
            birthday.push(excelData);
        });

        const key = ['Name', 'Company', 'Departments', 'Birthday', 'Hire Date'];
        exportCsv(birthday, key, 'Reports-Birthday', true);
    };

    handleSelectMenu = (e) => {
        const { date, currentPage, perPage } = this.state;
        const { birthdayReport } = this.props;
        const activeEmployee = isEmpty(birthdayReport.active) ? [] : birthdayReport.active.employees;
        const from = (currentPage - 1) * perPage;
        const to = currentPage * perPage;
        const employees = slice(from, to, activeEmployee);

        switch (e) {
            case 'print':
                BirthdayPDF({ employees, date });
                break;
            case 'export':
                this.handleExcelReport();
                break;
            default:
                break;
        }
    };

    render() {
        const { date, currentPage, perPage, userIds } = this.state;
        const { birthdayReport } = this.props;
        const activeEmployee = isEmpty(birthdayReport.active) ? [] : birthdayReport.active.employees;
        const from = (currentPage - 1) * perPage;
        const to = currentPage * perPage;
        const totalPage = Math.ceil(length(activeEmployee) / perPage);
        const menu = ['Profile'];
        const _employees = sortBy(prop('name'), activeEmployee);
        const selected = userIds.length === 0 ? slice(from, to, activeEmployee) : filter((e) => includes(e.id, userIds), _employees);
        const dotsMenu = ['Print', 'Export'];

        return (
            <ErrorBoundary className="mng-birthday">
                <Filter onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex ai-center mb-2">
                        <span className="dsl-b22 bold d-flex-1">Birthday Report</span>
                        <DatePicker calendar="range" append="caret" format="MMM DD, YY" as="span" align="right" value={date} onSelect={this.handleDate} />
                        <EditDropdown className="ml-3" options={dotsMenu} onChange={this.handleSelectMenu} />
                    </div>
                    <div className="list-header mt-4 desktop-screen">
                        <div className="d-flex d-flex-3 dsl-m12 text-400 cursor-pointer" onClick={() => this.handleSort('name')}>
                            Employee's Name
                            <span className="ml-1 sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-2 dsl-m12 text-400 cursor-pointer" onClick={() => this.handleSort('departments')}>
                            Department
                            <span className="ml-1 sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-2 dsl-m12 text-end text-400 cursor-pointer" onClick={() => this.handleSort('birth_date')}>
                            Birthday
                            <span className="ml-1 sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-2 dsl-m12 text-end text-400 cursor-pointer" onClick={() => this.handleSort('hired_at')}>
                            Hire Date
                            <span className="ml-1 sort-item d-flex-1">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-1 dsl-m12" />
                    </div>
                    {selected.map((employee) => {
                        const hireDate = moment(employee.hired_at).format('MMM DD, YY');
                        const birthday = isNil(employee.birthday) || isEmpty(employee.birthday) ? 'NA' : moment(employee.birthday).format('MMM DD, YY');
                        const username = employee.name.replace(/\s+/g, '-').toLowerCase();
                        return (
                            <div className="list-item d-flex ssm-column cursor-pointer" key={employee.id}>
                                <div className="d-h-between d-flex-3 dsl-m12 w-100 py-2">
                                    <div className="d-flex ai-center">
                                        <Avatar name={employee.name} url={employee.profile.avatar} onToggle={() => this.props.navigate(`/${employee.community_user.entity.slug}/about`)} />
                                        <span className="dsl-b14 ms-2 text-400 ms-3">{employee.name}</span>
                                    </div>
                                    <EditDropdown className="mobile-screen" options={menu} onChange={() => this.handleMenu(employee)} />
                                </div>
                                <div className="d-flex-2 d-flex w-100 ms-0 ssm-l-4">
                                    <label className="dsl-b14 mobile-screen w-40" onClick={() => this.handleSort('departments')}>
                                        Department
                                    </label>
                                    <span className="dsl-b14 text-400">{employee.department_name}</span>
                                </div>
                                <div className="d-flex-2 d-flex w-100 jc-end ssm-jc-start ms-0 ssm-l-4">
                                    <label className="dsl-b14 mobile-screen w-40" onClick={() => this.handleSort('birth_date')}>
                                        Birthday
                                    </label>
                                    <span className="dsl-b14 text-400">{birthday}</span>
                                </div>
                                <div className="d-flex-2 d-flex w-100 jc-end ssm-jc-start ms-0 ssm-l-4">
                                    <label className="dsl-b14 mobile-screen w-40" onClick={() => this.handleSort('hired_at')}>
                                        Hire Date
                                    </label>
                                    <span className="dsl-b14 text-400">{hireDate}</span>
                                </div>
                                <div className="d-flex-1 dsl-m12 text-end desktop-screen">
                                    <EditDropdown options={menu} onChange={() => this.handleMenu(employee)} />
                                </div>
                            </div>
                        );
                    })}
                    {selected.length >= perPage && <Pagination current={currentPage} per={perPage} total={totalPage} onChange={this.handlePage} onPer={this.handlePer} />}
                </div>
            </ErrorBoundary>
        );
    }
}

Birthday.propTypes = {
    userId: PropTypes.number,
    company: PropTypes.array,
    birthdayReport: PropTypes.shape({
        active: PropTypes.object,
        prior: PropTypes.object,
        recruit: PropTypes.object,
    }),
    getBirthdayReport: PropTypes.func,
    toggleModal: PropTypes.func,
};

Birthday.defaultProps = {
    userId: 0,
    company: { id: 0 },
    birthdayReport: { active: {}, prior: {}, recruit: {} },
    getBirthdayReport: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    userId: state.app.id,
    company: state.app.company_info,
    birthdayReport: state.manage.anniversarybirthdayReport,
});

const mapDispatchToProps = (dispatch) => ({
    getBirthdayReport: (companyId, base, payload) => dispatch(ManageActions.getanniversarybirthdayRequest(companyId, base, payload)),
    getUser: (payload, route) => dispatch(CommunityActions.getcommunityuserRequest(payload, null, route)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const BirthdayWithNavigate = withNavigate(Birthday);

export default connect(mapStateToProps, mapDispatchToProps)(BirthdayWithNavigate);
